/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlPostTestingCreateClientResponse } from './ControlPostTestingCreateClientResponse';
import {
    ControlPostTestingCreateClientResponseFromJSON,
    ControlPostTestingCreateClientResponseFromJSONTyped,
    ControlPostTestingCreateClientResponseToJSON,
} from './ControlPostTestingCreateClientResponse';
import type { ControlPostTestingUserResponse } from './ControlPostTestingUserResponse';
import {
    ControlPostTestingUserResponseFromJSON,
    ControlPostTestingUserResponseFromJSONTyped,
    ControlPostTestingUserResponseToJSON,
} from './ControlPostTestingUserResponse';

/**
 * 
 * @export
 * @interface ControlPostTestingCreateMSPClientResponse
 */
export interface ControlPostTestingCreateMSPClientResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlPostTestingCreateMSPClientResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPostTestingCreateMSPClientResponse
     */
    org_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlPostTestingCreateMSPClientResponse
     */
    entity_ids: Array<string>;
    /**
     * 
     * @type {Array<ControlPostTestingUserResponse>}
     * @memberof ControlPostTestingCreateMSPClientResponse
     */
    users: Array<ControlPostTestingUserResponse>;
    /**
     * 
     * @type {Array<ControlPostTestingCreateClientResponse>}
     * @memberof ControlPostTestingCreateMSPClientResponse
     */
    monitored: Array<ControlPostTestingCreateClientResponse>;
}

/**
 * Check if a given object implements the ControlPostTestingCreateMSPClientResponse interface.
 */
export function instanceOfControlPostTestingCreateMSPClientResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "entity_ids" in value;
    isInstance = isInstance && "users" in value;
    isInstance = isInstance && "monitored" in value;

    return isInstance;
}

export function ControlPostTestingCreateMSPClientResponseFromJSON(json: any): ControlPostTestingCreateMSPClientResponse {
    return ControlPostTestingCreateMSPClientResponseFromJSONTyped(json, false);
}

export function ControlPostTestingCreateMSPClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPostTestingCreateMSPClientResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'entity_ids': json['entity_ids'],
        'users': ((json['users'] as Array<any>).map(ControlPostTestingUserResponseFromJSON)),
        'monitored': ((json['monitored'] as Array<any>).map(ControlPostTestingCreateClientResponseFromJSON)),
    };
}

export function ControlPostTestingCreateMSPClientResponseToJSON(value?: ControlPostTestingCreateMSPClientResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
        'org_id': value.org_id,
        'entity_ids': value.entity_ids,
        'users': ((value.users as Array<any>).map(ControlPostTestingUserResponseToJSON)),
        'monitored': ((value.monitored as Array<any>).map(ControlPostTestingCreateClientResponseToJSON)),
    };
}

